import { LevelEditorComponent } from "../../../leveleditor.component";
import { MapItemTool } from "./MapItemTool";

export class GardenBedTool extends MapItemTool{
    public override ItemWidth: number = 60;
    public override ItemHeight: number = 30;
    public override Type = "GardenBed";
    public override OutlineColor = "854209";
    public override Opacity =  1;
    public override FillColor =  "bf8c4f";
    public override OutlineThickness = 2;
    constructor(editor: LevelEditorComponent, canvas: fabric.Canvas){
        super(editor, canvas);
    }
}
